/**
 * Menu tweaks
 */
// import $ from "jquery";

// $( document ).on( 'ready', function() {

//     function centerMenus() {
//         $( '.ubermenu-submenu-drop' ).each(function () {
//             var $this = $( this );
//             var $w = $this.outerWidth();
//             var $hw = $w / 2;
//             console.log( 'menu width ' + $hw );
//             $this.attr( 'style', 'margin-left: -' + ( $hw ) + 'px !important;' );
//         });
//     }
//     centerMenus();
//     $( window ).on( 'resize', function() {
//         centerMenus();;
//     });
// });

/**
 * Menu tweaks
 */
import $ from "jquery";

$( document ).on( 'ready', function() {

    // function centerMenus() {
    //     $( '.ubermenu-submenu-drop' ).each(function () {
    //         var $this = $( this );
    //         $this.attr( 'style', 'left: 0;' );
    //         var $hw = 0;
    //         var $w = $this.outerWidth();
    //         if ( $( window ).width() >= 992 ) {
    //             $hw = $w / 2;
    //         }
    //         $this.attr( 'style', 'margin-left: -' + ( $hw ) + 'px;' );
    //     });
    // }

    // centerMenus();
    // $( window ).on( 'resize', function() {
    //     centerMenus();;
    // });

    $( 'button.ubermenu-responsive-toggle' ).append( '<span class="toggle-burger"><span class="toggle-burger-bar"></span><span class="toggle-burger-bar"></span><span class="toggle-burger-bar"></span></span>' );
});